import Breadcrumbable from "./breadcrumbable";
import ToolbarActionable from "./toolbar-actionable";

export default {
	name: "PageableMixin",

	mixins: [
		Breadcrumbable,
		ToolbarActionable
	]
};
